module.exports = __webpack_public_path__ + "images/media-icon.svg";